import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useMutation, useApolloClient } from "react-apollo";
import { Fieldset, Field, Control, Button } from "rbx";

import { useLocation } from "react-router-dom";
import Section from "../Section";
import {
  CREATE_SYSTEM_CODE_MUTATION,
  ALL_SYSTEM_CODES_QUERY
} from "../../graphql/SystemCodes/SystemCodes.graphql";
import { ourToast as toast, getFilterState, omit } from "../../utils";
import SystemCodeForm from "./SystemCodeForm";

const AddSystemCodeForm = ({ setModalOpen, where }) => {
  const location = useLocation();
  const client = useApolloClient();
  const [state, setState] = useState({
    Category: where?.Category || "",
    CodeName: "0",
    CodeId: "",
    CodeDescription: "",
    Active: true,
    ListOrder: ""
  });

  const [createSystemCode, { loading }] = useMutation(
    CREATE_SYSTEM_CODE_MUTATION,
    {
      refetchQueries: ["ALL_SYSTEM_CODES_QUERY"]
    }
  );

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setState({ ...state, [e.target.name]: value });
  };
  useEffect(() => {
    const filtersName = location.pathname.includes("fleet")
      ? "SYSTEM_CODE_FLEET_FILTERS"
      : "SYSTEM_CODE_FILTERS";

    const filters = getFilterState(filtersName, {
      Active: true,
      Category: where?.Category || "",
      CodeName: "0"
    });
    setState(omit(filters, ["OR"]));
  }, [location.pathname, where]);

  const onSubmit = async e => {
    e.preventDefault();
    try {
      const {
        data: { SystemCodes }
      } = await client.query({
        query: ALL_SYSTEM_CODES_QUERY,
        variables: {
          where: {
            Category: state.Category,
            CodeName: state.CodeName,
            CodeId: state.CodeId
          },
          first: 1
        },
        fetchPolicy: "network-only"
      });
      if (SystemCodes?.length > 0) {
        toast.error(
          "This code already exists.  Please enter a different Code ID value."
        );
      } else {
        await createSystemCode({
          variables: {
            data: {
              ...state,
              ListOrder: state.ListOrder ? parseInt(state.ListOrder) : null
            }
          }
        });
        setModalOpen();
        toast.success("System Code added successfully.");
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <div style={{ width: "570px", minWidth: "570px" }}>
      {/* <pre>{JSON.stringify(state, null, 2)}</pre> */}
      <Section title="Add System Code">
        <form onSubmit={onSubmit}>
          <Fieldset disabled={loading}>
            <SystemCodeForm
              inputs={state}
              where={where}
              onChange={handleChange}
            />
            <hr />
            <Field kind="group">
              <Control>
                <Button color="success" type="submit">
                  Submit
                </Button>
              </Control>
              <Control>
                <Button type="button" onClick={() => setModalOpen(false)}>
                  Cancel
                </Button>
              </Control>
            </Field>
          </Fieldset>
        </form>
      </Section>
    </div>
  );
};

AddSystemCodeForm.propTypes = {
  setModalOpen: PropTypes.func,
  where: PropTypes.object
};
export default AddSystemCodeForm;
